import React, { ReactNode } from "react"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Avatar,
  Box,
  Flex,
  Text,
  Link,
} from "@chakra-ui/react"
import { Speaker } from "sharedTypes"
import Icon from "components/elements/Icon"
import SpeakerModalHeading from "./SpeakerModalHeading"
import RichDescription from "../../RichDescription"

type Props = {
  trigger: ReactNode
  speaker: Speaker
}

const SpeakerModal = ({
  trigger,
  speaker: {
    name, photoUrl, description, title, company, link,
  },
}: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const normalizedLink = link && (/^https?:\/\//i.test(link) ? link : `http://${link}`)

  return (
    <>
      <Box onClick={onOpen} cursor="pointer">
        {trigger}
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent overflow="hidden" w={500} bg="gray.100">
          <ModalCloseButton />
          <ModalBody p={0}>
            <Flex
              h={300}
              justifyContent="center"
              alignItems="center"
              p={6}
              backgroundColor="gray.200"
              borderBottomWidth={1}
              borderColor="gray.400"
            >
              <Avatar
                name={name}
                src={photoUrl}
                boxSize={250}
                sx={{ "& > div": { fontSize: "6xl" } }}
                bg="gray.300"
                borderWidth={1}
                borderColor="gray.400"
              />
            </Flex>
            <Flex flexDir="column" alignItems="center" justifyContent="center" py={8} px={8}>
              <Flex direction="column" align="center" gap={2}>
                <SpeakerModalHeading>{name}</SpeakerModalHeading>
                {(title || company) && (
                  <Text fontSize="xl" fontWeight="bold" align="center">
                    {[title, company].filter(Boolean).join(", ")}
                  </Text>
                )}
                {normalizedLink && (
                  <Link href={normalizedLink} isExternal>
                    <Icon icon="link-external" size={6} color="blue.500" />
                  </Link>
                )}
              </Flex>
              <RichDescription content={description} fontSize="lg" lineHeight="short" mt={4} />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default SpeakerModal
